export default __webpack_public_path__ + "static/media/evreux.d2bd88bc.jpg";